import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-58" data-mp="plslc7o6v6at">
      <div className="mx-auto max-w-4xl" data-id="element-59" data-mp="aujyg6bo7z1d">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-gold" data-id="element-60" data-mp="fu69c9411370">
          🎁 Bonus esclusivi
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-61" data-mp="1tlsvjll3jgo">
          In più, oggi ricevi questi 5 bonus
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] font-medium leading-relaxed text-inksoft sm:text-lg" data-id="element-62" data-mp="3o2n2xvnk40i2">
          Progettati per farti risparmiare tempo, migliorare la comunicazione con i pazienti e
          prendere decisioni più strutturate fin dal primo giorno.
        </p>

        <div className="-mx-4 mt-9 space-y-5 sm:mx-0" data-id="element-63" data-mp="1r8a4vjq9ize6">
          {bonuses.map(bonus => <article key={bonus.tag} className="overflow-hidden border-y border-brand-100 bg-cream sm:rounded-3xl sm:border" data-id="element-64" data-mp="3idmx9swgczdy">
              <img src={bonus.image} alt={`Mockup del bonus: ${bonus.title}`} className="block w-full" width={1260} height={1260} loading="lazy" data-id="element-65" data-mp="3r6qi4m9fgeim" />
              <div className="p-5 sm:p-6" data-id="element-66" data-mp="2zg3x7erz2r3o">
              <div className="flex flex-wrap items-center gap-2" data-id="element-67" data-mp="2ughb0fu620iq">
                <span className="rounded-full bg-gold px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.14em] text-ink" data-id="element-68" data-mp="2uibtlnhytgjn">
                  🎁 {bonus.tag}
                </span>
                <span className="text-[11px] font-bold uppercase tracking-wider text-inksoft line-through" data-id="element-69" data-mp="33fm6teecffr7">
                  Valore: {bonus.value}
                </span>
                <span className="rounded-full bg-brand-500 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-70" data-mp="irq1qpjjuuaq">
                  Gratis oggi
                </span>
              </div>

              <h3 className="mt-4 flex items-start gap-2 font-display text-[19px] font-bold leading-snug text-ink sm:text-xl" data-id="element-71" data-mp="3hgyc7g603sx9">
                <span aria-hidden="true" data-id="element-72" data-mp="3lke2lurh8x1i">{bonus.emoji}</span>
                <span data-id="element-73" data-mp="3qixt88h0mx07">{bonus.title}</span>
              </h3>

              {bonus.lead ? <p className="mt-3 text-[14px] font-semibold leading-snug text-ink/85 sm:text-[15px]" data-id="element-74" data-mp="2tt7zd5ggmj80">
                  {bonus.lead}
                </p> : null}

              {bonus.bullets.length > 0 ? <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-75" data-mp="32sbksg33napo">
                  {bonus.bullets.map(b => <li key={b} className="flex items-start gap-2" data-id="element-76" data-mp="37lein0ewt6bo">
                      <CheckIcon className="mt-[3px] h-4 w-4 shrink-0 text-brand-500" aria-hidden="true" data-id="element-77" data-mp="2a57iwjzazci4" />
                      <span className="text-[14px] font-medium leading-snug text-inksoft" data-id="element-78" data-mp="27jrgvn3u6dux">{b}</span>
                    </li>)}
                </ul> : null}

              {bonus.text ? <p className="mt-3 text-[14px] font-medium leading-relaxed text-inksoft sm:text-[15px]" data-id="element-79" data-mp="1xl29io9kgbsx">
                  {bonus.text}
                </p> : null}
              </div>
            </article>)}
        </div>

        <div className="mt-10" data-id="element-80" data-mp="1on8h3oexa2b1">
          <CtaButton label="Voglio il Kit + i 5 bonus" note="Bonus inclusi durante il lancio" data-id="element-81" data-mp="1juoz8f97cl0f" />
        </div>
      </div>
    </section>;
}